import React, { useState } from "react";
import rateCardItems from "./rateCardData"; // make sure data is imported from a flat list
import { motion, AnimatePresence } from "framer-motion";

const RateCard = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = rateCardItems
    .filter((item) =>
      item.desc.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => a.desc.localeCompare(b.desc));

  return (
    <div style={{ padding: 5, maxWidth: 800, margin: "auto" }}>
      <h1 className="text-3xl font-bold mb-4">Rate Card</h1>
      <p className="text-sm text-gray-600 italic mb-6">
        All prices include spare part cost and labour unless specified.
      </p>

      <div className="flex justify-start mb-6 px-4">
  <input
    type="text"
    placeholder="Search service..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="w-full max-w-md px-4 py-2 text-lg border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
  />
</div>
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: 2,
          padding: 10,
          margin: 0, // 👈 margin 0 – removes spacing between and sides
          backgroundColor: "#f9f9f9",
        }}
      >
        <AnimatePresence>
          <motion.div
            key="content"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4 }}
            className="mt-4"
          >
            {filteredData.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="min-w-full border border-black bg-white border-collapse">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="border border-black px-4 py-2 text-left text-black font-semibold">
                        Description
                      </th>
                      <th className="border border-black px-4 py-2 text-center text-black font-semibold">
                        Service Charge
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((item, i) => (
                      <tr
                        key={i}
                        className={i % 2 === 0 ? "bg-white" : "bg-gray-100"}
                      >
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "6px 8px",
                            fontSize: "10px",
                            color: "#000",
                          }}
                        >
                          {item.desc}
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "6px 8px",
                            fontSize: "10px",
                            textAlign: "center",
                            color: "#000",
                          }}
                        >
                          {item.price}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-gray-500 italic">
                No matching services found.
              </p>
            )}
          </motion.div>
        </AnimatePresence>
        <div style={{ height: "100px" }}></div>
      </div>
    </div>
  );
};

export default RateCard;
